import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import { alertService } from "components/Varios/alert_service";
import config from "config.json"
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { SolicitudesVacacionesPorRegistrarTH, PostFirmaMasivo } from "./TypesRegistroSolicitudesV";
import { SolicitudVacacionesRechazoDTO } from "components/DirectivoUnidad/AprobacionSolicitudes/TypesAprobacionSolicitudes";
import { handle_error } from "components/DirectivoUnidad/Vacaciones/helper_function";
import Swal from "sweetalert2";
import ExitoSVG from "./../../../assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "./../../../assets/icons/Permisos/Error.svg"

async function showAlert(message, imageSrc, isSuccess) {
    Swal.fire({
        text: message,
        imageUrl: `${imageSrc}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export async function ObtenerInformacionRegistros() {
    const URL = config.SERVER_URL + "AprobacionTh/RegistrosVacaciones";
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: SolicitudesVacacionesPorRegistrarTH[] | string = respuesta.data;

        if (typeof (datos) === "string") {
            resultado = { status: respuesta.status, dataResponse: datos }
        }
        else {
            const datosMapeados: SolicitudesVacacionesPorRegistrarTH[] = MapearSolicitudesVacacionesPorRegistrar(datos)
            resultado = { status: respuesta.status, dataResponse: datosMapeados }
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }
    }
    return resultado;
}

export function MapearSolicitudesVacacionesPorRegistrar(datos: SolicitudesVacacionesPorRegistrarTH[]) {
    const datosMapeados: SolicitudesVacacionesPorRegistrarTH[] = datos.map((val, ind) => {
        return {
            ...val,
        }
    })
    return datosMapeados
}

export async function VistaPreviaSolicitudVacaciones(idSolicitud: number, tipoSolicitud: string) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = config.SERVER_URL + "AprobacionTh/AprobarVacaciones/VistaPreviaFormulario/" + idSolicitud + "/" + tipoSolicitud;
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }
    return respuestaResponse
}

export async function RegistrarSolicitudVacaciones(idSolicitud: number, tipoSolicitud: string) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = config.SERVER_URL + "AprobacionTh/RegistroControlVacaciones/" + idSolicitud + "/" + tipoSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        if (tipoSolicitud == "Reintegro Vacación") {
            await showAlert("La Acción de Personal de Reintegro, ha sido registrada.", ExitoSVG, true);
            return 1;
        } else {
            await showAlert("La Acción de Personal de Vacaciones, ha sido registrada.", ExitoSVG, true);
            return 1;
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            alertService.error(error.response.data);
        }
        return -1;
    }
}

export async function AnularAccionPersonalVacacion(idSolicitud: number, datosRechazar: SolicitudVacacionesRechazoDTO, tipoSolicitud: string) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "AprobacionTh/AnularAPVacaciones/" + idSolicitud + "/" + tipoSolicitud;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.post(URL, datosRechazar,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        resultado = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }
    }
    return resultado;
}

export async function downloadExcelReport() {
    var currentUser: UserData = authenticationService.currentUserValue;
    if (!currentUser) { return -1 }

    await fetch(config.SERVER_URL + "AprobacionTh/RegistrosVacaciones/Reporte", {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `KEYESPOL ${currentUser?.token}`
        },
    })
        .then(response => {
            response.blob().then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = "Reporte Solicitudes por Registrar"
                a.click();
            });
        })
        .catch((error) => {
            var error_any: any = error;
            var status_code: number = handle_error(error_any);
            switch (status_code) {
                case 0 || -1:
                    alertService.error("No se ha podido establecer contacto con el servidor");
                    break;
                case 500:
                    alertService.error("Ha ocurrido un error inesperado");
                    break;
                default:
                    alertService.error("Ha ocurrido un error desconocido");
                    break;
            }
            window.scrollTo({
                top: 0,
                behavior: "auto"
            });
            return -1
        });
    return 1
}

export async function FirmaMasivaAccionPersonal(listadoSolicitudes: SolicitudesVacacionesPorRegistrarTH[]) {

    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "AprobacionTh/RegistroControlVacaciones/Masiva";

    const listadoIdSolicitudes: PostFirmaMasivo[] = listadoSolicitudes.map((s, i) => {
        return {
            idsolicitud: s.idSolicitudVacacion,
            tipoSolicitud: s.tipoSolicitud
        }
    })
    try {
        const respuesta = await axios.post(URL, { listadoSolicitudes: listadoIdSolicitudes },
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )

        const respuestaAprobacionMasiva: string[] = respuesta.data;

        if (respuestaAprobacionMasiva.length > 0) {
            const mensajesProblemas = respuestaAprobacionMasiva.map((mensaje, indimensaje) => {
                return mensaje + "\n";
            })
            await showAlert(mensajesProblemas, ErrorSVG, false);
        }
        else {
            await showAlert("Todas las acciones de personal fueron registradas", ExitoSVG, true);
        }
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            await showAlert(error.response.data, ErrorSVG, false);
            return -1;
        }
    }
    return 1;
}